import React from 'react'
import {Outlet, useMatches} from 'react-router-dom'
import {VmoHelmet} from 'vmo-library'

const supportTitle = 'Veemo Support'

const DocumentTitle = () => {
  const matches = useMatches()
  const titles = matches
    // first get rid of any matches that don't have handle and title
    .filter(match => Boolean(match.handle?.title))
    // now map them into an array of elements, passing the loader
    // data to each one
    .map(match => match.handle?.title)

  const documentTitle = () => {
    if (titles.length) {
      return `${titles.reverse().join(' | ')} - ${supportTitle}`
    }
    return supportTitle
  }

  return (
    <>
      <VmoHelmet>
        <title>{documentTitle()}</title>
      </VmoHelmet>
      <Outlet />
    </>
  )
}

export default DocumentTitle
